module.exports = __webpack_public_path__ + "img/36b3167.jpeg";